import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function Refund() {
  return (
    <LegalLayout title="Refund and Cancellation Policy" lastUpdated="February 26, 2026">
      <p>
        We want you to be satisfied with <strong>Facade Lighting Studio</strong>. This policy describes when refunds are
        available and how to request one.
      </p>

      <h2>1. Pro subscriptions (monthly / yearly)</h2>
      <ul>
        <li>
          <strong>7-day no-questions-asked refund:</strong> if you purchase a Pro subscription and request a refund within
          7 days of purchase <em>and</em> have NOT used the AI Finalize feature, we will refund the full amount.
        </li>
        <li>
          If you have used AI Finalize during the 7-day window, we may offer a partial refund at our discretion based on
          usage.
        </li>
        <li>
          After 7 days, the subscription is non-refundable for the current period. You can let it expire to stop further
          billing — we use one-time charges, not auto-renewing subscriptions, so nothing renews automatically.
        </li>
      </ul>

      <h2>2. AI credit packs</h2>
      <ul>
        <li>
          <strong>Unused packs:</strong> if you purchase an AI credit pack and have not used any of the credits, you may
          request a full refund within 7 days of purchase.
        </li>
        <li>
          <strong>Partially used packs:</strong> once any credit has been spent, the pack is non-refundable.
        </li>
        <li>Credits never expire — you can use them at your own pace.</li>
      </ul>

      <h2>3. Cancellation</h2>
      <p>
        Because we use one-time charges (not auto-renewing subscriptions), there is nothing to cancel — your access simply
        ends when the paid period expires (30 or 365 days). You can re-subscribe at any time at the then-current pricing.
      </p>

      <h2>4. Failed payments and duplicate charges</h2>
      <p>
        If you see a duplicate charge or a payment that does not match a successful subscription on your account, email us
        immediately at <a href="mailto:xpertzankur@gmail.com">xpertzankur@gmail.com</a> with the transaction reference.
        Verified duplicates are refunded in full.
      </p>

      <h2>5. How to request a refund</h2>
      <p>
        Email <a href="mailto:xpertzankur@gmail.com">xpertzankur@gmail.com</a> with:
      </p>
      <ul>
        <li>Your account email address</li>
        <li>The payment date and amount</li>
        <li>The transaction ID from Stripe / Razorpay (visible in your card statement or UPI app)</li>
        <li>A short reason (helps us improve the product, but not required)</li>
      </ul>
      <p>
        Approved refunds are processed back to the original payment method within 5–10 business days. Bank processing time
        is determined by your bank/card issuer and is outside our control.
      </p>

      <h2>6. Exceptions</h2>
      <p>
        Refunds may be denied in cases of suspected fraud, abuse of the refund policy (e.g., repeated subscribe-and-refund
        cycles), or violation of our <a href="/terms">Terms of Service</a>.
      </p>

      <h2>7. Contact</h2>
      <p>
        Questions about refunds? Email <a href="mailto:xpertzankur@gmail.com">xpertzankur@gmail.com</a>. We aim to reply
        within 2 business days.
      </p>
    </LegalLayout>
  );
}
